import { put, call, all, takeLatest } from 'redux-saga/effects';
import { API_ENDPOINTS } from 'src/config/api-endpoints';
import { axiosInstance } from '../../../utils/axios/axios-instance';
import * as actions from './actions';

function* getSummaryList(action: ReturnType<typeof actions.getSummaryList.request>): Generator {
  try {
    const { filter, sort, pagination } = action.payload;
    const response = yield call(axiosInstance.get, API_ENDPOINTS.SUMMARY_REPORT.Summary, {
      params: { sort, ...filter, ...pagination },
    });

    yield put(actions.getSummaryList.success((response as any).data));
  } catch (err) {
    yield put(actions.getSummaryList.failure(err));
  }
}

function* getSummaryDetailList(action: ReturnType<typeof actions.getSummaryDetailList.request>): Generator {
  try {
    const { filter, sort, pagination } = action.payload;
    const response = yield call(axiosInstance.get, API_ENDPOINTS.SUMMARY_REPORT.Details, {
      params: { sort, ...filter, ...pagination },
    });

    yield put(actions.getSummaryDetailList.success((response as any).data));
  } catch (err) {
    yield put(actions.getSummaryDetailList.failure(err));
  }
}

function* getIncomeSummaryList(action: ReturnType<typeof actions.getIncomeSummaryList.request>): Generator {
  try {
    const { filter, sort, pagination } = action.payload;
    const response = yield call(axiosInstance.get, API_ENDPOINTS.INCOME_REPORT.IncomeSummary, {
      params: { sort, ...filter, ...pagination },
    });

    yield put(actions.getIncomeSummaryList.success((response as any).data));
  } catch (err) {
    yield put(actions.getIncomeSummaryList.failure(err));
  }
}

function* getIncomeDetailList(action: ReturnType<typeof actions.getIncomeDetailList.request>): Generator {
  try {
    const { filter, sort, pagination } = action.payload;
    const response = yield call(axiosInstance.get, API_ENDPOINTS.INCOME_REPORT.IncomeDetails, {
      params: { sort, ...filter, ...pagination },
    });

    yield put(actions.getIncomeDetailList.success((response as any).data));
  } catch (err) {
    yield put(actions.getIncomeDetailList.failure(err));
  }
}

function* getReportSummary(action: ReturnType<typeof actions.getReportSummary.request>): Generator {
  try {
    const { filter, sort, pagination } = action.payload;
    const response = yield call(axiosInstance.get, API_ENDPOINTS.INCOME_REPORT.ReportSummary, {
      params: { sort, ...filter, ...pagination },
    });

    yield put(actions.getReportSummary.success((response as any).data));
  } catch (err) {
    yield put(actions.getReportSummary.failure(err));
  }
}

function* getReportFullDetails(action: ReturnType<typeof actions.getReportFullDetails.request>): Generator {
  try {
    const { filter, sort, pagination } = action.payload;
    const response = yield call(axiosInstance.get, API_ENDPOINTS.INCOME_REPORT.ReportFullDetails, {
      params: { sort, ...filter, ...pagination },
    });

    yield put(actions.getReportFullDetails.success((response as any).data));
  } catch (err) {
    yield put(actions.getReportFullDetails.failure(err));
  }
}

function* getReportDetails(action: ReturnType<typeof actions.getReportDetails.request>): Generator {
  try {
    const { filter, sort, pagination } = action.payload;
    const response = yield call(axiosInstance.get, API_ENDPOINTS.INCOME_REPORT.ReportDetails, {
      params: { sort, ...filter, ...pagination },
    });

    yield put(actions.getReportDetails.success((response as any).data));
  } catch (err) {
    yield put(actions.getReportDetails.failure(err));
  }
}



// Main saga
export default function* incomeSaga() {
  yield all([
    takeLatest(actions.getSummaryList.request, getSummaryList),
    takeLatest(actions.getSummaryDetailList.request, getSummaryDetailList),
    takeLatest(actions.getIncomeSummaryList.request, getIncomeSummaryList),
    takeLatest(actions.getIncomeDetailList.request, getIncomeDetailList),
    takeLatest(actions.getReportSummary.request, getReportSummary),
    takeLatest(actions.getReportFullDetails.request, getReportFullDetails),
    takeLatest(actions.getReportDetails.request, getReportDetails),
  ]);
}
